export default {
  links: 'Crea links en segundos',
  addDetails: 'Añade todos los detalles de la compra.',
  sendLink: 'Envía tu link de pago',
  share: 'Compártelo por correo, whatsapp o redes sociales.',
  receivePayment: 'Recibe tu pago',
  maximumTime: 'En un máximo de 48 horas hábiles.',
};
